import React from 'react';
import PropTypes from 'prop-types';
import BlurReveal from '../../BlurReveal';

/* A hero row: a plain tag, or a BlurReveal block when the hero reveals (the
 * HeroBannerV3 helper, kept local to each hero). */
const Row = ({ reveal, delay, duration, lift, blur, as: Tag = 'div', className, children, ...rest }) =>
  reveal ? (
    <BlurReveal variant="block" as={Tag} delay={delay} duration={duration} lift={lift} blur={blur} className={className} {...rest}>
      {children}
    </BlurReveal>
  ) : (
    <Tag className={className} {...rest}>{children}</Tag>
  );

Row.propTypes = {
  reveal: PropTypes.bool,
  delay: PropTypes.number,
  duration: PropTypes.number,
  lift: PropTypes.bool,
  blur: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Row;
